<template>
  <button type="button" class="btn-days-work" :class="{ active: active }">
    {{ dayOfTheWeek.name }}
  </button>
</template>

<script>
export default {
  props: {
    dayOfTheWeek: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-days-work {
  width: 100px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--white);
  border: 1px solid var(--gray-1);
  border-radius: 30px;
  font-size: 10px;
  font-family: "Font Semibold";
  color: var(--black);
  transition: 500ms;
  &.active {
    background: var(--gray-1);
  }
}
</style>
